import { SentimentWordConfig } from './types';

export const ruSentimentWordConfig: SentimentWordConfig = {
    positiveWords: new Set([
        'активный',
        'безопасно',
        'безопасный',
        'готово',
        'готовый',
        'доверие',
        'здоровый',
        'полезно',
        'полезный',
        'победа',
        'позитивный',
        'поддержка',
        'помощь',
        'прекрасно',
        'прогресс',
        'радость',
        'развитие',
        'решено',
        'рост',
        'сильный',
        'спокойный',
        'стабильно',
        'стабильный',
        'успех',
        'хороший',
        'хорошо',
        'ценно',
        'ясно',
        'вдохновение',
        'вдохновляющий',
        'выигрыш',
        'готовность',
        'доброта',
        'доволен',
        'дружелюбный',
        'достижение',
        'защита',
        'замечательно',
        'исправлено',
        'крепкий',
        'легко',
        'любовь',
        'надежда',
        'надежный',
        'одобрено',
        'отлично',
        'поддержано',
        'порядок',
        'приятный',
        'рад',
        'счастье',
        'уверенно',
        'уверенный',
        'улучшение',
        'улучшено',
        'устойчивый',
        'ценный',
        'чудесно',
        'чисто',
        'эффективно',
        'аккуратно',
        'бодро',
        'важный',
        'великолепно',
        'восстановлен',
        'вперед',
        'доброжелательный',
        'достойный',
        'здорово',
        'комфорт',
        'красиво',
        'крепко',
        'лучший',
        'мирно',
        'молодец',
        'надежно',
        'нежность',
        'облегчение',
        'ободряющий',
        'подъем',
        'победный',
        'польза',
        'понятно',
        'потрясающе',
        'признан',
        'приятно',
        'проверено',
        'процветание',
        'радостный',
        'ровно',
        'светло',
        'смело',
        'созидание',
        'спасение',
        'тепло',
        'удача',
        'улыбка',
        'устроено',
        'целый',
        'честно',
    ]),
    negativeWords: new Set([
        'авария',
        'баг',
        'беда',
        'блок',
        'боль',
        'вред',
        'задержка',
        'зло',
        'кризис',
        'медленно',
        'негативный',
        'ненавижу',
        'неудача',
        'опасно',
        'опасный',
        'отказ',
        'ошибка',
        'плохо',
        'плохой',
        'провал',
        'проблема',
        'регрессия',
        'риск',
        'слабый',
        'срочно',
        'страх',
        'угроза',
        'хаос',
        'аварийный',
        'беспокойство',
        'блокировка',
        'болезненный',
        'враждебный',
        'грустно',
        'давление',
        'дефект',
        'депрессия',
        'застрял',
        'злой',
        'катастрофа',
        'критично',
        'ломается',
        'мертвый',
        'напряжение',
        'неисправность',
        'ненадежный',
        'обидно',
        'отвратительно',
        'паника',
        'печаль',
        'под угрозой',
        'поломка',
        'потеря',
        'пугающий',
        'раздражает',
        'сломано',
        'стресс',
        'тревога',
        'трудно',
        'ужасный',
        'уязвимый',
        'хаотично',
        'хуже',
        'шаткий',
        'сбой',
        'агрессивный',
        'болит',
        'больной',
        'брешь',
        'грубо',
        'давит',
        'досадно',
        'жесткий',
        'запрет',
        'изнурительный',
        'испорчен',
        'катастрофический',
        'коллапс',
        'кошмар',
        'ломкий',
        'мерзкий',
        'напряженно',
        'ненужный',
        'неприятный',
        'обвал',
        'обуза',
        'огорчение',
        'опасность',
        'отсталый',
        'подавленный',
        'поздно',
        'поломан',
        'помеха',
        'пугает',
        'разрушение',
        'смутно',
        'токсичный',
        'тяжело',
        'хрупкий',
        'черный',
    ]),
};
